/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_no_teams_filters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No teams match your filters`)
};

const es_f1_apex_no_teams_filters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ningún equipo coincide con tus filtros`)
};

const de_f1_apex_no_teams_filters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Teams entsprechen deinen Filtern`)
};

const nl_f1_apex_no_teams_filters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen teams voldoen aan je filters`)
};

const fr_f1_apex_no_teams_filters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune équipe ne correspond à vos filtres`)
};

const it_f1_apex_no_teams_filters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna squadra corrisponde ai tuoi filtri`)
};

const pt_br2_f1_apex_no_teams_filters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum time corresponde aos seus filtros`)
};

const pt_f1_apex_no_teams_filters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma equipa corresponde aos teus filtros`)
};

const ja_f1_apex_no_teams_filters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フィルターに一致するチームがありません`)
};

const zh_f1_apex_no_teams_filters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有符合筛选条件的阵容`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_no_teams_filters = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_no_teams_filters(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_no_teams_filters", locale)
	if (locale === "en") return en_f1_apex_no_teams_filters(inputs)
	if (locale === "es") return es_f1_apex_no_teams_filters(inputs)
	if (locale === "de") return de_f1_apex_no_teams_filters(inputs)
	if (locale === "nl") return nl_f1_apex_no_teams_filters(inputs)
	if (locale === "fr") return fr_f1_apex_no_teams_filters(inputs)
	if (locale === "it") return it_f1_apex_no_teams_filters(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_no_teams_filters(inputs)
	if (locale === "pt") return pt_f1_apex_no_teams_filters(inputs)
	if (locale === "ja") return ja_f1_apex_no_teams_filters(inputs)
	return zh_f1_apex_no_teams_filters(inputs)
};